import { SelectBox } from 'src/components/SelectBox';
import { CardWithBorder } from 'src/components/CardWithBorder';
import { WarningPanel } from 'src/components/WarningPanel';
import { days, timeOptions } from './constants';
import { useContactWindow } from './ContactWindowContext';

export const WeeklyContactWindow = () => {
  const {
    selectedDays,
    toggleDay,
    startTime,
    endTime,
    setStartTime,
    setEndTime,
    showScheduleWarning,
    scheduleWarningAccepted,
    setScheduleWarningAccepted,
  } = useContactWindow();
  return (
    <CardWithBorder>
      <h3 className="mb-2">Outreach Schedule</h3>
      <p className="text-sm text-neutral-500 mb-4">
        Select when to send messages or place calls.
      </p>
      <div className="flex gap-2 flex-wrap mb-4">
        {days.map((d) => {
          const active = selectedDays.includes(d.value);
          return (
            <button
              key={d.value}
              type="button"
              onClick={() => toggleDay(d.value)}
              className={`px-6 py-2 rounded-full border ${
                active
                  ? 'bg-primary/10 text-primary border-primary/20'
                  : 'bg-neutral-0 text-neutral-700 border-neutral-200'
              }`}
            >
              {d.label}
            </button>
          );
        })}
      </div>
      <div className="flex flex-col gap-2">
        <span className="text-sm text-neutral-500">Allowed contact times</span>
        <div className="flex items-center gap-4">
          <SelectBox
            options={timeOptions}
            value={startTime}
            onChange={(v) => {
              const option = timeOptions.find((o) => o.value === v);
              if (option) setStartTime(option);
            }}
          />
          <span className="text-sm text-neutral-500">to</span>
          <SelectBox
            options={timeOptions}
            value={endTime}
            onChange={(v) => {
              const option = timeOptions.find((o) => o.value === v);
              if (option) setEndTime(option);
            }}
          />
        </div>
      </div>
      <WarningPanel
        show={showScheduleWarning}
        title="Call time outside legal hours"
        acknowledgement={{
          checked: scheduleWarningAccepted,
          onChange: setScheduleWarningAccepted,
          label:
            'I acknowledge that placing calls outside permitted hours may result in legal penalties.',
        }}
        className="mt-4"
      >
        The call time you chose falls outside the legally permitted window for
        consumer sales calls &mdash; typically 9 a.m. to 8 p.m., Monday through
        Saturday, though exact limits vary by state. Placing a call at this time
        could subject your company to significant fines.
      </WarningPanel>
    </CardWithBorder>
  );
};

export default WeeklyContactWindow;
